//
//  SDKBorderStyle.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var BorderStyle;
(function (BorderStyle) {
    BorderStyle["dashed"] = "Dashed";
    BorderStyle["dotted"] = "Dotted";
    BorderStyle["solid"] = "Solid";
    BorderStyle["groove"] = "Groove";
})(BorderStyle || (BorderStyle = {}));
export const ALL_BORDER_STYLES = [
    BorderStyle.dashed,
    BorderStyle.dotted,
    BorderStyle.solid,
    BorderStyle.groove,
];
